<template>
  <div>
    <overlay-loading :loading="loading.tableData">
      <template #content>
        <b-table
          :fields="fields"
          :items="formData.payload"
          responsive
          sticky-header
          borderless
          show-empty
          class="default-static-table m-0"
        >
          <template #cell(no)="data">
            <span>{{ data.item.transaction_id || '-' }}</span>
          </template>
          <template #cell(date)="data">
            <span>{{ resolveDate(data.item.tx_time) || '-' }}</span>
          </template>
          <template #cell(time)="data">
            <span>{{ resolveTime(data.item.tx_time) || '-' }}</span>
          </template>
          <template #cell(reward)="data">
            <span>{{ data.item.privilege_name_th || '-' }}</span>
          </template>
          <template #cell(point)="data">
            <span>{{ data.item.point_total || '-' }}</span>
          </template>

          <template #table-busy>
            <overlay-loading :loading="true" />
          </template>
          <template #empty>
            <card-no-item :text-no-img="'Item Not Found'" />
          </template>
        </b-table>
      </template>
    </overlay-loading>
  </div>
</template>

<script>
import { BTable } from 'bootstrap-vue'

import usePrivilegeHistory from '../hooks/usePrivilegeHistory'

export default {
  components: { BTable },

  setup() {
    const {
      formData,
      fields,
      loading,
      resolveDate,
      resolveTime,
    } = usePrivilegeHistory()

    return {
      formData,
      fields,
      loading,
      resolveDate,
      resolveTime,
    }
  },
}
</script>

<style></style>

<style scoped>
@import '~@/assets/css/pages/data-management/privilege-history.css';
</style>
